import ReactMarkdown from "react-markdown";

const mdComponents = {
  h1: ({ children }) => <h1 className="text-2xl font-black tracking-tight text-zinc-950 mt-6 mb-3 font-heading">{children}</h1>,
  h2: ({ children }) => <h2 className="text-xl font-bold tracking-tight text-zinc-900 mt-5 mb-2 font-heading">{children}</h2>,
  h3: ({ children }) => <h3 className="text-lg font-bold text-zinc-900 mt-4 mb-2 font-heading">{children}</h3>,
  p: ({ children }) => <p className="text-[15px] text-zinc-700 leading-[1.8] mb-4">{children}</p>,
  ul: ({ children }) => <ul className="list-disc pl-5 mb-4 space-y-1">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal pl-5 mb-4 space-y-1">{children}</ol>,
  li: ({ children }) => <li className="text-[15px] text-zinc-700 leading-relaxed">{children}</li>,
  strong: ({ children }) => <strong className="font-semibold text-zinc-900">{children}</strong>,
};

export function MdOut({ content }) {
  return (
    <div className="prose-output" data-testid="markdown-output">
      <ReactMarkdown components={mdComponents}>{content}</ReactMarkdown>
    </div>
  );
}
